import { httpClient } from '@/infra/protocols/http';
import { IScriptDTO } from '@/modules/scripts/dtos/script.dto';
import { IScript } from '@/modules/scripts/entities/script.entity';
import { ScriptMapper } from '@/modules/scripts/mappers/script.mapper';

export async function updateVoiceAssociate(
  params: UpdateVoiceAssociateService.Params,
  data: UpdateVoiceAssociateService.Payload,
): Promise<UpdateVoiceAssociateService.Response> {
  const body = { idVoz: data.voiceId };

  const response = await httpClient.put<IScriptDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/blocos/${params.blockId}`,
    body,
  );

  return ScriptMapper.toPresentation(response);
}

export namespace UpdateVoiceAssociateService {
  export interface Params {
    blockId: number;
    projectId: string;
    podcastId: string;
    episodeId: string;
  }

  export interface Payload {
    voiceId: number;
  }

  export type Response = IScript;
}
